<template>
  <div class="loginFooter-wrapper">粤ICP备18161349号-1 Copyright © 广州白云金科控股集团有限公司</div>
</template>

<script type="text/ECMAScript-6">
  export default {
    name: 'LoginFooter'
  };
</script>

<style lang="sass" rel="stylesheet/sass" scoped>
  @import "LoginFooter.sass"
</style>
